import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mantine/dates';
import Button from 'ps-components/Button/Button';
import './AgeToCalendarSelect.scss';
export default class AgeToCalendarSelect extends Component {
  static propTypes = {
    selectDate: PropTypes.func,
    selectedDate: PropTypes.string,
    defaultAgingDate: PropTypes.string,
    reset: PropTypes.func,
    canReset: PropTypes.bool,
    benchmarkYear: PropTypes.number
  };

  getMaxDate() {
    if (this.props.benchmarkYear) {
      return new Date(this.props.benchmarkYear + 2, 11, 31);
    }

    return null;
  }

  getDefaultDate() {
    if (this.props.defaultAgingDate) {
      const dateParts = this.props.defaultAgingDate.split('-');

      /** create a new date with year, month, day arguments, decrementing month by one because month is 0-indexed */
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    }

    return null;
  }

  render() {
    return (
      <div className="aging__datepicker">
        <Button className="aging__reset" onClick={this.props.reset} disabled={this.props.canReset}>
          Reset to Default Aging
        </Button>
        <h3 className="aging__datepicker-heading">Pick an Age To Date</h3>
          <DatePicker
          className='aging__datepicker__calendar'
          size="md"
          value={this.props.selectedDate}    
          onChange={this.props.selectDate}      
          defaultDate={this.getDefaultDate()}      
          minDate={this.getDefaultDate()}      
          maxDate={this.getMaxDate()}/>
      </div>
    );
  }
}